<div class="baseContainer container-fluid twoScreenPageWrapper">
	<!--HEADER/ACTION ROW-->
	<div class="headerAndActionRow row">
		<div class="col-12 headerAndActionRowContent">
			<div class="titleWithIcon">
				<div class="icon">
					<i class="fa-2x {{ headerIcon.fontSet }} {{ headerIcon.fontIcon }}"></i>
				</div>

				<div class="title">
					<h1 class="mat-h1 nomargin">{{ translatedHeader }}</h1>
				</div>
			</div>

			<div class="adminSettingsPageActionCon">
				<div [class.showing]="filterFieldShowing" class="filterField">
					<mat-form-field class="full-width-form" color="accent">
						<mat-label>{{ T.SHARED_BASIC_ADMINISTRATION_TABLE_FILTER | translate }}</mat-label>
						<input #filterInput [formControl]="filterInputFormControl" matInput placeholder="" />
					</mat-form-field>
				</div>
				@if (showFilter) {
					<button (click)="openFilterField(filterInput)" class="searchButton" color="accent" mat-icon-button>
						<sim-animated-material-icon
							[endIcon]="{
								fontSet: 'fad',
								fontIcon: 'fa-times',
								themeColor: 'warn',
							}"
							[startIcon]="{
								fontSet: 'fad',
								fontIcon: 'fa-search',
								themeColor: 'accent',
							}"
							[trigger]="filterFieldShowing"
						/>
					</button>
				}

				@if (hasAdditionalActions) {
					<div class="adminSettingsPageAction additionalActions">
						<button [matMenuTriggerFor]="additionalActionsMenue" class="large" color="accent" mat-icon-button>
							<mat-icon fontIcon="fa-chevron-down" fontSet="far" inline />
						</button>
						<mat-menu #additionalActionsMenue="matMenu">
							<ng-content select="[additionalActions]" />
						</mat-menu>
					</div>
				}
			</div>
		</div>

		<div class="col-12">
			<mat-divider class="headerDivider" />
		</div>
	</div>

	<!--VIRTUAL SCROLL TABLE-->
	<div class="contentTableRow row">
		<div class="col-12 exampleTableContainerWrapper">
			<cdk-virtual-scroll-viewport
				appendOnly
				class="exampleTableContainer mat-elevation-z8"
				footerHeight="0"
				headerHeight="63"
				id="contentTableHolder"
				tvsItemSize="60"
			>
				<sim-component-loading-container
					[isLoading]="isLoadingResults"
					[loadingIcon]="'fad ' + titleIcon"
					[loadingMessage]="T.GENERAL_TXT_LOADING | translate: {loadingParam: title}"
				/>

				<mat-table
					[class.loadingData]="isLoadingResults"
					[dataSource]="dataSource"
					[trackBy]="TrackByMethods.trackById"
					class="contentTable"
					multiTemplateDataRows
				>
					<ng-content select="[tableColumns]" />

					<mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" />
					<mat-row
						*matRowDef="let element; let i = renderIndex; columns: displayedColumns; when: isNotGroup"
						[class.collapsed]="isCollapsed(element)"
						[class.hasExpandedElement]="enableExpandElement"
						class="example-element-row"
						mat-ripple
						mat-row
					/>

					<ng-container matColumnDef="groupHeader">
						<mat-cell *appMatCellDef="let groupBy; dataSource: dataSource" mat-cell>
							<div class="groupName">
								{{ groupBy.initial.toUpperCase() }}
							</div>
						</mat-cell>
					</ng-container>

					@if (isGrouped) {
						<mat-row
							*matRowDef="let row; columns: ['groupHeader']; when: isGroup"
							class="example-element-row groupRow"
							mat-row
						/>
					}
				</mat-table>

				@if (dataSource?.data?.length <= 0 && !isLoadingResults) {
					<div class="noElementsQueriedContainer">
						<div class="icon">
							<i class="fad {{ titleIcon }} fa-3x"></i>
						</div>
						<div class="text mat-h2 nomargin">
							{{ T.BASE_ADMINISTRATION_TABLE_NO_ELEMENT_FOUND | translate: {title: title ?? "Element"} }}
						</div>
					</div>
				}
			</cdk-virtual-scroll-viewport>
		</div>
	</div>
</div>
